import Vue from 'vue';
import FormulateInputUrl from './components/FormulateInputs/FormulateInputUrl';

Vue.component('FormulateInputUrl', FormulateInputUrl);

export const formulateSetup = {
  library: {
    url: {
      classification: 'text',
      component: 'FormulateInputUrl',
    },
  },
  errorHandler(error) {
    if ('formErrors' in error) {
      return error;
    }
    if (error.response.status) {
      switch (error.response.status) {
        case 400: {
          const formErrors = error.response.data.non_field_errors || [];
          if (error.customFormErrors) {
            Object.keys(error.response.data).forEach((key) => {
              if (error.customFormErrors[key]) {
                formErrors.push(error.customFormErrors[key]);
              }
            });
          }
          return {
            formErrors,
            inputErrors: error.response.data,
          };
        }
        default:
          return {
            formErrors: [
              `Unknown error ocurred, status code ${error.response.status}.`,
            ],
          };
      }
    }
    return {
      formErrors: [`Unknown error ocurred: ${error.message}.`],
    };
  },
};
